import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  IconButton,
  Grid,
  Container,
  Divider
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Star as StarIcon,
  Work as WorkIcon
} from '@mui/icons-material';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,


  // ... your existing imports
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";

// Sample data - replace with your actual data
// Icon mapping for common keys
const iconMap = {
  qualification: <SchoolIcon sx={{ color: "#512da8", fontSize: 18 }} />,
  expertise: <WorkIcon sx={{ color: "#512da8", fontSize: 18 }} />,
  workExperience: <BusinessCenterIcon sx={{ color: "#512da8", fontSize: 18 }} />,
  name: <PersonIcon sx={{ color: "#512da8", fontSize: 18 }} />,
  credentials: <BadgeIcon sx={{ color: "#512da8", fontSize: 18 }} />,
  associatedWith: <BadgeIcon sx={{ color: "#512da8", fontSize: 18 }} />
};
const convertedBoardMembers = [
  {
    name: "Dr. D.V. Bhatt",
    qualification: "Ph.D., M.E., B.E. (Mechanical), DBM, IPMM, Fellow Member (IE-I)",
    image: "/membersphoto/d.v-bhatt.jpg",
    expertise: [
      "Idea generation and entrepreneurship promotion",
      "Productivity improvement techniques",
      "Placements",
      "Management systems study and application",
      "Career guidance",
      "Work and method study",
      "IPR (Intellectual Property Rights)"
    ],
    workExperience: [
      "45+ years of experience in academics and industry",
      "Guided 11 Ph.D. research scholars",
      "Guided 40 postgraduate dissertations",
      "6 granted Indian patents",
      "85+ national and international publications",
      "Visited 12 countries for academic and professional purposes"
    ],
    credentials: [
      "Fellow Member of Institution of Engineers (India)",
      "Recognized Ph.D. guide",
      "Expert in productivity and management systems",
      "Renowned speaker and mentor in innovation and entrepreneurship"
    ],
    associatedWith: [
      "IE(I) SGLC Surat",
      "ISTE",
      "TSI",
      "SGPC Surat"
    ]
  }
  // ,
  // {

  //   name: "Piyush Kumar P. Bhatt",
  //   qualification: "M.Com. (Statistics)",
  //   image: "/membersphoto/piyush-bhatt.jpg",
  //   expertise: [
  //     "Personality Development",
  //     "Youths Programming",
  //     "Languages known like Gujarati, Hindi, Sanskrit, English, Urdu etc...",
  //     "Carrier Development"
  //   ],
  //   workExperience: [
  //     "38 years Banking carrier as an officer",
  //     "More then 40 years experience of stage & performing arts",
  //     "Connected with different forms of art and literature since long",
  //     "Invited as guest faculty for enterprineur guidance in different government departments, NGOs & many educational institutions",
  //     "Motivational speaker & mantoring students"
  //   ],
  //   // ... other fields
  // },
  // {
  //   name: "Mr. Dipak Lukhdhir",
  //   qualification: "N/A",
  //   expertise: [
  //     "Entrepreneurship",
  //     "Career Development"
  //   ],
  //   workExperience: [
  //     "Development Officer at CED (1984–1986)",
  //     "Supervisor at Khadi Village Industries Commission (1990–1991)",
  //     "Assistant Project Leader at CED (1991–1996)",
  //     "Deputy Project Leader at CED (2004–2015)",
  //     "Regional Officer at CED (2011–Present)",
  //     "Project Leader at CED (2015–Present)"
  //   ],
  //   credentials: "N/A",
  //   associatedWith: "CED (Centre for Entrepreneurship Development)",
  //   image: "/membersphoto/DipakLukhdhir.jpg"
  // }
  // ,
  // {
  //   name: "Mr. Mayank Jadav",
  //   qualification: "B.Tech - Computer Science & Engineering ,Charusat - Anand ",
  //   expertise: [
  //     "Software Development",
  //     "Web Development",
  //     "AI/ML",
  //     "MS Office",
  //     "Canva"
  //   ],
  //   workExperience: [
  //     "1+ years in Web Development",
  //     "6+ months in AI/ML"
  //   ],
  //   credentials: "N/A",
  //   associatedWith: "N/A",
  //   image: "/membersphoto/MayankJadav.JPG"
  // },
  // {
  //   name: "Mr. Nitin Oza",
  //   qualification: "B.E. (Mechanical) - 1974, M.E. (Mechanical) - 1978 , SVNIT Surat",
  //   expertise: [
  //     "Entrepreneurship Training",
  //     "Career Guidance",
  //     "Product Development",
  //     "Communication",
  //     "Finance",
  //     "Training and Development (HR)"
  //   ],
  //   workExperience: [
  //     "Executive Committee Member at The Institution of Engineers (India), Gujarat (2009 – Present)",
  //     "Owner at Surat Prestech Private Limited (Jan 1984 – Present)",
  //     "Managing Director at Surat Prestech Private Limited (Jan 1984 – Present)"
  //   ],
  //   credentials: "President - SWAJAN (Spastic Society of Surat), President - Surat Management Association",
  //   associatedWith: "Surat Prestech Private Limited, The Institution of Engineers (India)",
  //   image: "/membersphoto/nitin-oza.jpg"
  // }
  ,
  // {
  //   name: "Mr. Anupam Jain",
  //   qualification: [
  //     "MBA (Finance) - FMS, Mohan Lal Sukhadia University",
  //     "Certified Financial Planner (CFP) - FPSB India",
  //     "NISM-Series-XXI-A - PMS Distributors Certification",
  //     "NISM Series V-A - Mutual Fund Distributors Certification",
  //     "JAIIB & CAIIB - Indian Institute of Banking and Finance (IIBF)",
  //     "Certificate Course in Foreign Exchange - IIBF",
  //     "Licentiate - Insurance Institute of India, Mumbai"
  //   ],
  //   expertise: [
  //     "Financial Planning",
  //     "Investment Management",
  //     "Retirement Planning",
  //     "Estate Planning",
  //     "Tax Optimization",
  //     "Risk Management",
  //     "Banking and Wealth Management"
  //   ],
  //   workExperience: [
  //     "Founder & CEO at Shreeji Finmart (Present)",
  //     "14+ years in Financial Services Industry",
  //     "Previous roles at: State Bank of India, Bank of Baroda, Kotak Mahindra Bank, Axis Bank Ltd."
  //   ],
  //   credentials: "Multiple NISM Certifications, JAIIB & CAIIB, Certified Financial Planner (CFP)",
  //   associatedWith: "Shreeji Finmart, State Bank of India, Bank of Baroda, Kotak Mahindra Bank, Axis Bank Ltd.",
  //   image: "/membersphoto/anupam-jain.jpg"
  // }
  // ,
  {
    name: "Mr. Jitendra Dina",
    qualification: "Bachelor of Commerce",
    expertise: [
      "Business Real / Labgrown Diamond trading and Manufacturing of Gold, Diamond and Platinum Jewellery ",
    ],
    workExperience: " 30+ years.",
    credentials: "N/A",
    associatedWith: "N/A",
    image: "/membersphoto/Jitendra-dina.jpg"
  },
  // {
  //   name: "Mr. Mayur R. Patel",
  //   qualification: "B.Com, LL.B, LL.M, Ph.D. (Pursuing) in Criminal Law",
  //   expertise: [
  //     "Criminal Law",
  //     "Advocacy",
  //     "Legal Education",
  //     "Social Leadership",
  //     "Organizational Management"
  //   ],
  //   workExperience: [
  //     "Practicing Advocate",
  //     "ABVP Karyakarta (1989 to 2000) - Active in Gujarat",
  //     "RSS Nagar Karyvah - Adajan, Surat (2014 to 2016)",
  //     "VHP Jilla Sahmantri - Rander, Surat (2021)",
  //     "Council Member - Surat District Bar Association (2023)",
  //     "Active Member - Rashtriya Swayamsevak Sangh (RSS) till present"
  //   ],
  //   credentials: "Vice President",
  //   associatedWith: "Surat District Bar Association, RSS, VHP, ABVP",
  //   image: "/membersphoto/mayur-patel.jpg"
  // }
  ,
  {
    name: "Mrs. Suniti Karwa",
    qualification: "Bachelors",
    expertise: [
      "Women's Entrepreneurship",
      "Women's Empowerment",
      "Social Work"
    ],
    workExperience: "15+ years",
    credentials: "N/A",
    associatedWith: "N/A",
    image: "/membersphoto/suniti-karwa.jpg"
  },
  {
    name: "Mr. Ranjitkumar Chaudhary",
    qualification: "Bachelors",
    expertise: [
      "Social Work",
      "Community Engagement",
      "Public Welfare Initiatives"
    ],
    workExperience: "10+ years",
    credentials: "Managing director at Unigen enterprise, Founder Ramkrishna Human Welfare Society (RKHWS) ",
    associatedWith: "NYCS",
    image: "/membersphoto/ranjit-chaudhary.jpg"
  },
  // {
  //   name: "Mr. Kishore Vaghela",
  //   qualification: "B.A. (Economics), M.A. - Part 1 (Sociology)",
  //   expertise: [
  //     "Canteen Management",
  //     "Agency Operations",
  //     "Consultancy",
  //     "Educational and Social Service"
  //   ],
  //   workExperience: [
  //     "ABVP (Akhil Bharatiya Vidyarthi Parishad) - 1985 to 2000",
  //     "BJYM (Bharatiya Janata Yuva Morcha) - 2000 to 2006",
  //     "BJP (Bharatiya Janata Party) - 2006 to Present",
  //     "Member - University Board - 1999 to 2012",
  //     "Member - Sixan Samiti - 2010 to 2015",
  //     "President - Surat Digital Mall",
  //     "Director - Shahpore Urban Co-operative Society, Surat City"
  //   ],
  //   credentials: "Chairman - SCHETO Hockey Association Gujarat, President - Surat Digital Mall",
  //   associatedWith: "BJP, SCHETO Hockey Association, Shahpore Urban Co-operative Society",
  //   image: "/membersphoto/kishor-vaghela.jpg"
  // }


];

function MrSpecialist() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            mb: 2,
            background: 'linear-gradient(to right, #1976d2, #512da8)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold'
          }}
        >
          Our Knowledge partners
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
          Meet our team of highly qualified  professionals
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {convertedBoardMembers.map((specialist) => (
          <Grid item xs={12} key={specialist.id}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 220,
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 12px 40px rgba(25, 118, 210, 0.15)',
                },
                borderRadius: 3,
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
              }}
            >
              {/* Image + Name + Qualification Section */}
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  background: 'linear-gradient(135deg, #1976d2, #512da8)',
                  p: 3,
                  gap: 3,
                  flexWrap: 'wrap',
                }}
              >
                <Avatar
                  src={specialist.image}
                  alt={specialist.name}
                  sx={{
                    width: 180,
                    height: 180,
                    border: '4px solid rgba(255, 255, 255, 0.9)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    flexShrink: 0
                  }}
                />
                <Box sx={{ color: '#fff' }}>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 'bold', mb: 0.5 }}
                  >
                    {specialist.name}
                  </Typography>
                  {specialist.qualification && (
                    <Typography
                      variant="body2"
                      sx={{
                        fontStyle: 'italic',
                        color: '#e0e0ff',
                        fontSize: '0.9rem',
                      }}
                    >
                      {specialist.qualification}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Content Section */}
              <CardContent
                sx={{
                  flex: 1,
                  p: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  '&:last-child': { pb: 0 },
                }}
              >
                <TableContainer sx={{ flex: 1 }}>
                  <Table size="small">
                    <TableBody>
                      {Object.entries(specialist).map(([key, value]) => {
                        // Skip fields already shown in image section
                        if (['image', 'name', 'qualification'].includes(key)) return null;

                        return (
                          <TableRow key={key}>
                            <TableCell
                              sx={{
                                width: '25%',
                                fontWeight: 'bold',
                                color: '#1976d2',
                                borderRight: '1px solid #e0e0e0',
                                backgroundColor: '#f8f9ff',
                                verticalAlign: 'top',
                                py: 2,
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {iconMap[key] || <PersonIcon sx={{ color: '#512da8', fontSize: 18 }} />}
                                {key
                                  .replace(/([A-Z])/g, ' $1')
                                  .replace(/^./, (str) => str.toUpperCase())}
                              </Box>
                            </TableCell>
                            <TableCell sx={{ verticalAlign: 'top', py: 2 }}>
                              {Array.isArray(value) ? (
                                <Box>
                                  {value.map((item, index) => (
                                    <Typography
                                      key={index}
                                      variant="body2"
                                      color="text.primary"
                                      sx={{ mb: 0.5 }}
                                    >
                                      • {item}
                                    </Typography>
                                  ))}
                                </Box>
                              ) : (
                                <Typography variant="body2" color="text.primary">
                                  {value}
                                </Typography>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Divider />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>


    </Container>
  );
}

export default MrSpecialist;